<template>
    <v-container class="d-flex flex-column align-center justify-center"
        style="min-height: 100vh; max-width: 700px; color: black;">
        <div class="tos-card">
            <h1 class="text-center mb-6">Terms of Service</h1>

            <v-card class="pa-4 mb-4" elevation="2" max-height="400" style="overflow-y: auto">
                <p>
                    <!-- You can replace this with a <v-markdown> component or fetch from a .md or .txt file -->
                    By using duallo, you agree to the terms and conditions outlined below. Duallo is a support tool and
                    does not replace
                    formal inspections. AI outputs are assistive in nature and should not be treated as guarantees of
                    accuracy or completeness.
                </p>
                <div style="justify-items: center;">
                    <v-btn class="mt-6" color="primary" text :href="pdfTermsOfServiceUrl" target="_blank">
                        View Full Terms (PDF)
                    </v-btn>
                    <br />
                    <v-btn class="mt-6" color="primary" text :href="pdfPrivacyPolicyUrl" target="_blank">
                        View Privacy Policy (PDF)
                    </v-btn>
                </div>
            </v-card>

            <v-checkbox v-model="accepted" label="I have read and agreed to the Terms of Service & Privacy Policy"
                hide-details />

            <v-btn color="primary" :disabled="!accepted" class="mt-4" @click="acceptTerms">
                Continue
            </v-btn>

            <v-alert v-if="errorMessage" type="error" class="mt-4">
                {{ errorMessage }}
            </v-alert>
        </div>
    </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth0 } from "@auth0/auth0-vue"
import { useOrganizationStore } from '@/store/organizationStore';
import DualloUserService from '@/services/DualloUserService';

const pdfTermsOfServiceUrl = 'https://dualloapp.blob.core.windows.net/legal/duallo%20-%20ToS%20-%2007_Aug_2025.pdf?sv=2023-01-03&spr=https&st=2025-08-07T16%3A37%3A42Z&se=2050-08-08T16%3A37%3A00Z&sr=b&sp=r&sig=pp90Uk1trZ9%2F7FsiQ1%2BH9QL6zj3t6saZVGjydgG5NqU%3D';
const pdfPrivacyPolicyUrl = 'https://dualloapp.blob.core.windows.net/legal/duallo%20-%20Privacy%20Policy%20-%207_Aug_2025.pdf?sv=2023-01-03&spr=https&st=2025-08-07T17%3A16%3A53Z&se=2050-08-08T17%3A16%3A00Z&sr=b&sp=r&sig=7LQ%2F9gGqSK0wDtpnPSBbN2rEbzxYt5YN3XoSzHEW1oY%3D';

const accepted = ref(false)
const errorMessage = ref(null)
const router = useRouter()

const organizationStore = useOrganizationStore()
const { user } = useAuth0()

async function acceptTerms() {
    const userService = new DualloUserService();
    const response = await userService.acceptTermsofService(organizationStore.organizationId, user.value.sub);

    if (response != null && response.acceptedTermsOfService) {
        router.push('/');
    } else {
        errorMessage.value = "Could not confirm. Contact support@duallo.ai to get assistance.";
    }
}

</script>

<style>
.tos-card {
    background-color: var(--duallo-card-start);
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
    color: #fff;
    width: 100%;
    justify-items: center;
}
</style>